var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogAssignTask" }, [
    _c("div", { staticClass: "modal-card", staticStyle: { width: "460px" } }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(
            _vm._s(_vm.isEdit ? "עריכת שיבוץ משימה" : "שיבוץ משימה בתכנית")
          ),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("div", { staticClass: "course-context" }, [
            _vm._v(" שיבוץ בקורס הנוכחי: "),
            _c("strong", [_vm._v(_vm._s(_vm.courseName))]),
          ]),
          _c(
            "b-field",
            { attrs: { label: "משימה משויכת לקורס" } },
            [
              _c("FieldInlineSelect", {
                attrs: {
                  label: "בחירת משימה",
                  placeholder: "הקלד שם / מזהה משימה מהמשימות המשויכות לקורס",
                  "alert-not-exist": true,
                  "hide-hover": true,
                  clearable: true,
                  filterable: true,
                  "read-only": _vm.isEdit,
                  options: [],
                  "fetch-options": _vm.onSearchTasks,
                  "initial-option": _vm.taskInitialOption,
                },
                on: { onChange: _vm.onChange },
                model: {
                  value: _vm.model.id,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "id", $$v)
                  },
                  expression: "model.id",
                },
              }),
            ],
            1
          ),
          _c(
            "b-field",
            { attrs: { label: "סוג תוכנית" } },
            [
              _c(
                "b-select",
                {
                  attrs: {
                    placeholder: "בחר סוג תוכנית",
                    expanded: "",
                    disabled: _vm.isEdit,
                  },
                  model: {
                    value: _vm.model.programTypeId,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "programTypeId", $$v)
                    },
                    expression: "model.programTypeId",
                  },
                },
                _vm._l(_vm.programTypes, function (p) {
                  return _c(
                    "option",
                    { key: p.Value, domProps: { value: p.Value } },
                    [_vm._v(_vm._s(p.Text))]
                  )
                }),
                0
              ),
            ],
            1
          ),
          _c(
            "b-field",
            { attrs: { label: "תאריך" } },
            [
              _c("b-datepicker", {
                attrs: {
                  icon: "calendar-today",
                  placeholder: "בחר תאריך",
                  "trap-focus": "",
                  editable: "",
                },
                model: {
                  value: _vm.model.date,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "date", $$v)
                  },
                  expression: "model.date",
                },
              }),
            ],
            1
          ),
          _c("b-field", { attrs: { label: "חלון זמן (TimeWindow)" } }, [
            _c(
              "div",
              { staticClass: "time-window" },
              _vm._l(_vm.timeWindows, function (w) {
                return _c(
                  "button",
                  {
                    key: w.Value,
                    class: { on: _vm.model.timeWindow === w.Value },
                    style:
                      _vm.model.timeWindow === w.Value
                        ? {
                            background: w.color,
                            borderColor: w.color,
                            color: "#fff",
                          }
                        : {},
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.model.timeWindow = w.Value
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "dot",
                      style: { background: w.color },
                    }),
                    _vm._v(_vm._s(w.Text) + " "),
                  ]
                )
              }),
              0
            ),
          ]),
          _c(
            "div",
            { staticClass: "times" },
            [
              _c(
                "b-field",
                { attrs: { label: "שעת התחלה" } },
                [
                  _c("b-timepicker", {
                    attrs: {
                      "hour-format": "24",
                      icon: "clock",
                      placeholder: "08:00",
                    },
                    model: {
                      value: _vm.model.startTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "startTime", $$v)
                      },
                      expression: "model.startTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { label: "שעת סיום" } },
                [
                  _c("b-timepicker", {
                    attrs: {
                      "hour-format": "24",
                      icon: "clock",
                      placeholder: "12:00",
                    },
                    model: {
                      value: _vm.model.endTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "endTime", $$v)
                      },
                      expression: "model.endTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-field", { attrs: { label: "משך המשימה (דקות)" } }, [
            _c(
              "div",
              { staticClass: "duration" },
              [
                _c("b-input", {
                  attrs: {
                    type: "number",
                    min: "1",
                    step: "1",
                    placeholder: _vm.durationPlaceholder,
                    expanded: "",
                  },
                  model: {
                    value: _vm.model.durationMinutes,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "durationMinutes", $$v)
                    },
                    expression: "model.durationMinutes",
                  },
                }),
                _vm.isDurationOverridden
                  ? _c("span", { staticClass: "duration-badge" }, [
                      _vm._v("מותאם לתוכנית"),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("p", { staticClass: "duration-hint" }, [
            _vm._v(_vm._s(_vm.durationHint)),
          ]),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              type: "is-primary",
              label: _vm.isEdit ? "שמור" : "שייך משימה",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "ביטול" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }